import React, { useEffect } from "react";

// Store
import { pathTitles, useStore } from "../../Store/Store";
// Components
import { Loader, PageOverLay, SEO, TrainingInfo } from "..";

export const BTPuppy = () => {
  const checkServices = useStore((state) => state.checkServices);
  const getLink = useStore((state) => state.getLink);
  const loading = useStore((state) => state.loading);
  const trainingDetails = useStore((state) => state.trainingDetails);
  const btPuppyPrograms = useStore((state) => state.btPuppyPrograms);

  useEffect(() => {
    checkServices(trainingDetails);
  }, []);
  const overlay = {
    where: "btPuppy",
    title: "Board and Train for Puppies",
    caption:
      "Four sold Buy A Trained Puppies eagerly heel with Justine in an open field.",
  };
  const info = {
    routes: {
      Home: "/",
      Training: getLink(pathTitles.TRAINING),
      "Board And Train": getLink(pathTitles.BOARDANDTRAIN),
      "Board And Train for Puppies": getLink(pathTitles.BOARDANDTRAINPUPPY),
    },
    body: trainingDetails.BOARDANDTRAINPUPPY.body,
    programs: btPuppyPrograms,
  };
  return (
    <>
      <SEO
        title="Board and Train for Puppies"
        description="Puppy Board & Train programs built around socialization, foundation obedience, potty training, and confidence. Give your puppy the best possible start. Indianapolis and surrounding areas."
        path="/training/board-and-train-puppy"
      />
      {loading ? (
        <Loader />
      ) : (
        <>
          <PageOverLay overlay={overlay} />
          <TrainingInfo info={info} />
        </>
      )}
    </>
  );
};
